import React, { useState } from 'react';
import {
  Box,
} from '@mui/material';
import { TLookupTextField } from '../../../../components/common';
import { type ProveedorFiltered } from '../types/proveedor';
import ProveedorSelectionModal from './ProveedorSelectionModal';

interface ProveedorLookupProps {
  label?: string;
  value?: string;
  onChange?: (idPersona: number, razonSocial: string) => void;
  error?: string;
  required?: boolean;
  fullWidth?: boolean;
  placeholder?: string;
  modalTitle?: string;
  disabled?: boolean;
}

const ProveedorLookup: React.FC<ProveedorLookupProps> = ({
  label = 'Proveedor',
  value = '',
  onChange,
  error,
  required = false,
  fullWidth = true,
  placeholder = 'Seleccione un proveedor',
  modalTitle = 'Seleccionar Proveedor',
  disabled = false
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleClear = () => {
    if (onChange) {
      onChange(0, ''); // Reset to empty values
    }
  };

  const handleSelectProveedor = (proveedor: ProveedorFiltered) => {
    if (onChange) {
      onChange(proveedor.idPersona, proveedor.razonSocial);
    }
    setModalOpen(false);
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <TLookupTextField
        label={label}
        value={value}
        error={error}
        required={required}
        fullWidth={fullWidth}
        placeholder={placeholder}
        onSearchClick={disabled ? undefined : handleOpenModal}
        onClear={disabled ? undefined : handleClear}
        searchTooltip="Buscar Proveedor"
        clearTooltip="Limpiar Proveedor"
        disabled={disabled}
      />

      <ProveedorSelectionModal
        open={modalOpen}
        onClose={handleCloseModal}
        onSelect={handleSelectProveedor}
        title={modalTitle}
      />
    </Box>
  );
};

export default ProveedorLookup;